import { MenuItem, Tooltip } from '@blueprintjs/core';
import {
  lock_hooks,
  useApplicationDetail,
  useClawbackApplication,
} from '@axo/shared/data-access/hooks';
import { loan_application } from '@axo/shared/data-access/types';
import styles from './ClawbackApplicationButton.module.css';
import { useConfirmDialog } from '../../../hooks/utils/useConfirmDialog';

export function ClawbackApplicationButton({
  applicationID,
}: {
  applicationID: string;
}) {
  const clawbackApplication = useClawbackApplication();
  const app = useApplicationDetail(applicationID);
  const { confirm } = useConfirmDialog();
  const hasLock = lock_hooks.useCurrentUserHasLock(
    applicationID,
    app.data?.MarketCountry
  ).data;

  const handleClawback = async () => {
    confirm({
      message:
        'Are you sure you want to clawback this application? It is irreversible.',
      confirmText: 'Clawback',
      cancelText: 'Cancel',
      confirmCallback: async () => {
        await clawbackApplication.mutateAsync(applicationID);
      },
    });
  };

  const isDisabled = () => {
    return (
      app.data?.Status !==
      loan_application.ApplicationStatus.ApplicationStatusLoanDisbursed
    );
  };

  return (
    <Tooltip
      disabled={!isDisabled()}
      placement={'left'}
      content={'Clawback can only be performed on a disbursed application'}
      fill
    >
      <MenuItem
        icon="take-action"
        className={styles.redText}
        onClick={handleClawback}
        disabled={!hasLock || clawbackApplication.isLoading || isDisabled()}
        text="Clawback"
      />
    </Tooltip>
  );
}
